import { useTranslation } from 'react-i18next';
import { Boxes } from 'lucide-react';
import { Link } from '@/components/ui/link';

const CONTACT_EMAIL = 'zula@derinbay.com';

const SECTION_KEYS = [
  'acceptance',
  'eligibility',
  'serviceDescription',
  'acceptableUse',
  'userContent',
  'availability',
  'intellectualProperty',
  'fees',
  'termination',
  'liability',
  'changes',
  'governingLaw',
] as const;

export function TermsOfServicePage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-muted/40">
      <div className="mx-auto max-w-2xl px-4 py-10">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-primary-foreground">
            <Boxes className="h-5 w-5" />
          </div>
          <div>
            <p className="font-semibold">{t('app.name')}</p>
            <p className="text-sm text-muted-foreground">{t('app.tagline')}</p>
          </div>
        </div>

        <h1 className="text-2xl font-semibold">{t('terms.title')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('terms.lastUpdated')}</p>

        <p className="mt-6 text-sm leading-relaxed text-foreground">{t('terms.intro')}</p>

        <div className="mt-8 space-y-8">
          {SECTION_KEYS.map((key) => (
            <section key={key}>
              <h2 className="text-lg font-semibold">{t(`terms.${key}Title`)}</h2>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{t(`terms.${key}Body`)}</p>
            </section>
          ))}

          <section>
            <h2 className="text-lg font-semibold">{t('terms.contactTitle')}</h2>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              {t('terms.contactBody', { email: CONTACT_EMAIL })}
            </p>
          </section>
        </div>

        <div className="mt-10">
          <Link to="/login" intent="quiet">
            {t('terms.back')}
          </Link>
        </div>
      </div>
    </div>
  );
}
